// extracted by mini-css-extract-plugin
module.exports = {"outdoor-recreation-J":"J_outdoor-recreation-J__igU0K"};